import React from "react";

import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

const Terms: React.FC = () => {
    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">Our Terms & Conditions</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            By accessing or using SACA’s services, you agree to be bound by
                            these Terms and Conditions. Please read them carefully.
                        </p>
                    </div>
                </div>
            </div>

            <div className=" flex flex-col py-16 w-full px-4 md:px-14 bg-white">
                <div className="max-w-4xl mx-auto w-full">
                    <div className="font-Manrope space-y-12 w-full">
                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Account Registration
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "Users must be 16 years or older to create an account.",
                                    "All registration details must be accurate and current.",
                                    "You are responsible for maintaining the confidentiality of your login credentials."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Subscription & Payments
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "SACA offers multiple subscription plans: Free, Pro 1, Pro 2, and Pro 3.",
                                    "Payments are billed monthly in Nigerian Naira (₦).",
                                    "Subscription cancellations can be done anytime; however, no partial refunds will be issued for unused periods."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Match Booking
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "All bookings must be made via the SACA platform.",
                                    "Cancellations must be made at least 12 hours before the match.",
                                    "Repeated no-shows or late arrivals may result in penalties or account suspension."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Code of Conduct
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "Respectful behavior is required during matches and community interactions.",
                                    "Any form of violence, harassment, or disruptive conduct is strictly prohibited.",
                                    "SACA reserves the right to suspend or ban any user violating these rules."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Loyalty & Rewards
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "Users who play 10+ matches per month may be rewarded with a free match.",
                                    "The admin has the discretion to approve or deny free match requests."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className=" text-2xl md:text-3xl font-black text-gray-900 mb-6 flex items-center gap-3">
                                <span className="w-2 h-8 bg-green-700 rounded-full" />
                                Liability & Termination
                            </h2>
                            <ul className="space-y-4 list-none text-gray-700">
                                {[
                                    "Participation is at the user's own risk; SACA is not liable for injuries or loss.",
                                    "SACA may terminate your account without notice for violating terms.",
                                    "We reserve the right to modify these terms at any time."
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-4">
                                        <span className="text-green-700 font-bold">0{i + 1}.</span>
                                        <p className="text-lg font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <div className="mt-16 p-10 bg-gray-50 rounded-[40px] border border-gray-100 text-center">
                            <h3 className="text-2xl font-black text-gray-900 mb-4">Questions?</h3>
                            <p className="text-gray-500 font-medium mb-8">For any inquiries regarding our terms, please contact our support team.</p>
                            <a href="mailto:support@saca.com.ng" className="text-green-700 font-black text-xl hover:underline">support@saca.com.ng</a>
                        </div>
                    </div>
                </div>
            </div>
            <Banner />
            <Footer />
        </>
    );
};

export default Terms;
